<template>
	<div class="client-container" :class="'client-container-' + currentPage">
		<div id="client-background-elements">
			<no-drag-image class="fixed-top fixed-left" src="@/assets/client/paper_cropped_transparent.png" :scale="bgScale" />
			<no-drag-image class="fixed-top fixed-right" src="@/assets/client/phone_cropped_transparent.png" :scale="bgScale" />
			<no-drag-image class="fixed-bottom fixed-left" src="@/assets/client/dictaphone_cropped_transparent.png" :scale="bgScale" />
			<no-drag-image class="fixed-bottom fixed-right" src="@/assets/client/microphone_cropped_transparent.png" :scale="bgScale"/>
		</div>

		<div id="client-page-container" :class="middleAlign ? 'middle-align' : ''">
			<client-intro-view v-if="currentPage === 'intro'" />
			<client-register-view v-else-if="currentPage === 'register'" />
			<client-vote-view v-else-if="currentPage === 'vote'" />
		</div>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import { mapGetters } from 'vuex'

	import ClientIntroView from '@/views/flow/client/00-Intro.vue';
	import ClientRegisterView from '@/views/flow/client/01-Register.vue';
	import ClientVoteView from '@/views/flow/client/02-Vote.vue';

	const pageComponentDefault = 'intro';

	export default {
		name: 'client-view',
		components: {
			ClientIntroView,
			ClientRegisterView,
			ClientVoteView,
		},
		data() {
			return {
				bgScale: 0.3
			}
		},
		computed: {
			middleAlign() {
				return false;
			},
			currentPage() {
				let page = this.$route.meta.childPage;

				if (typeof(page) !== 'string' || page === '') {
					page = pageComponentDefault;
				}

				return page;
			},
		},
	}
</script>

<style lang="scss" scoped>
	.client-container {
	}

	#client-background-elements {
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: 0;
		left: 0;
		top: 0;
		@include noSelect();
	}

	#client-page-container {
		position: relative;
		z-index: 100;

		&.middle-align {
			@include alignCenter();

		}
	}

	.fixed-left {
		position: fixed;
		left: 0;
		text-align: left;
	}

	.fixed-right {
		position: fixed;
		right: 0;
		text-align: right;
	}

	.fixed-top {
		position: fixed;
		top: 0;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}
</style>
